const common = {
    no_data: 'គ្មានទិន្នន័យទេ',
    header: {
        business_name: 'អាជីវកម្មរបស់អ្នក'
    },
    download_app: {
        text: 'ដើម្បីប្រើកំណែវែបសាយ Simply សូមប្រើកុំព្យូទ័រ ឬ កុំព្យូទ័រយួរដៃ។',
        button: 'ទាញយកកំណែទូរស័ព្ទ'
    },
    unknown: 'មិនស្គាល់',
    request_error: 'មានបញ្ហាកើតឡើង។ សូមព្យាយាមម្តងទៀត ឬ ទាក់ទងក្រុមគាំទ្រ។',
    home: 'ទំព័រដើម',
    dashboard: 'ផ្ទាំងគ្រប់គ្រង',
    product: 'ផលិតផល',
    add_product: 'បន្ថែមផលិតផល',
    edit_product: 'កែផលិតផល',
    stock_in: 'បញ្ចូលស្តុក',
    Sales_Turnover: 'ចំណូលការលក់',
    profit: 'ប្រាក់ចំណេញ',
    stock_out: 'ដកស្តុកចេញ',
    staff: 'បុគ្គលិក',
    stock_audit: 'ត្រួតពិនិត្យស្តុក',
    button: {
        save: 'រក្សាទុក',
        save_and_add_more: 'រក្សាទុក & បន្ថែមទៀត',
        submit: 'ដាក់ស្នើ',
        done: 'រួចរាល់',
        edit: 'កែ',
        save_edit: 'រក្សាទុកការកែប្រែ',
        yes: 'បាទ/ចាស',
        clear: 'សម្អាត',
        delete: 'លុប',
        cancel: 'បោះបង់',
        reset: 'កំណត់ឡើងវិញ'
    },
    select_date: 'ជ្រើសរើសកាលបរិច្ឆេទ',
    select_action: 'ជ្រើសសកម្មភាព',
    mandatory: ' *(ត្រូវបំពេញ)',
    not_mandatory: '(មិនចាំបាច់បំពេញ)',
    business: 'អាជីវកម្ម',
    account: 'គណនី',
    profile: 'ប្រវត្តិរូប',
    setting: 'ការកំណត់',
    whichLanguage: 'ភាសាអង់គ្លេស',
    headerDashboard: 'ក្លាយជាវីអាយភី',
    contact_us: 'ទំនាក់ទំនងយើងខ្ញុំ',
    logout: 'ចេញពីប្រព័ន្ធ',
    category: 'ប្រភេទ',
    add_category: 'បន្ថែមប្រភេទ',
    data: 'ទិន្នន័យ',
    history: 'ប្រវត្តិ',
    lowStockAlert: 'ការជូនដំណឹងស្តុកអស់',
    Expenses: 'ចំណាយ',
    lowStockAlertButton: 'បន្ថែមចំនួនស្តុកសុវត្ថិភាព',
    message: {
        login_success: 'បានចូលប្រើដោយជោគជ័យ!',
        onboard_success: 'សូមអបអរសាទរ!! ការធ្វើដំណើររបស់អ្នកបានចាប់ផ្តើម!',
        successfully_saved: 'ទិន្នន័យត្រូវបានរក្សាទុកដោយជោគជ័យ',
        successfully_deleted: 'ទិន្នន័យត្រូវបានលុបដោយជោគជ័យ',
        error_required_field: 'វាលនេះត្រូវបំពេញ',
        no_access: 'គ្មានសិទ្ធិចូល',
        no_permission: "អ្នកគ្មានសិទ្ធិ",
        error_update_history: 'បរាជ័យក្នុងការអាប់ដេតប្រវត្តិ'
    },
    no_permission_dialog: {
        title: 'គ្មានសិទ្ធិ',
        description: 'អ្នកគ្មានសិទ្ធិមើលចំណាយ។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។'
    },
    feedback: 'ផ្តល់មតិឆ្លើយតប',
    contact: 'ទំនាក់ទំនង',
    add: 'បន្ថែម',
    supplier: 'អ្នកផ្គត់ផ្គង់',
    customer: 'អតិថិជន',
    random: 'ចៃដន្យ',
    scan: 'ស្កែន',
    enter: 'ចូលដោយស្កែនបាកូដ',
    terms: {
        text: 'ដោយបន្ត អ្នកយល់ព្រមនឹង',
        link: 'គោលការណ៍ភាពឯកជន'
    },
    others: 'ផ្សេងៗ',
    calender: {
        presets: {
            today: 'ថ្ងៃនេះ',
            yesterday: 'ម្សិលមិញ',
            last_7_days: '៧ថ្ងៃចុងក្រោយ',
            last_30_days: '៣០ថ្ងៃចុងក្រោយ',
            this_month: 'ខែនេះ',
            last_month: 'ខែមុន',
            custom_range: 'ជួរផ្ទាល់ខ្លួន'
        }
    },
    print_large: 'បោះពុម្ពធំ (A4)',
    print_letter: 'បោះពុម្ព Letter (US)',
    print_dot_matrix: 'បោះពុម្ពធំ (Dot Matrix)',
    print_medium: 'បោះពុម្ពមធ្យម (75mm)',
    print_small: 'បោះពុម្ពតូច (48mm)',
    format: 'ទម្រង់ក្រដាស',
    preview: 'មើលជាមុន',
    view_invoice: 'វិក្កយបត្រ',
    view_chalan: 'បញ្ជារទំនិញ',
    price: 'តម្លៃ',
    stock: 'ស្តុក',
    quantity: 'បរិមាណ',
    total: 'សរុប',
    print_footer_left: 'បង្កើតដោយ',
    print_footer_center: 'បោះពុម្ពនៅ',
    print_footer_date: 'នៅ',
    print_to: 'ទៅ',
    language: 'ភាសាអង់គ្លេស',
    dateStatus: '៧ថ្ងៃចុងក្រោយ',
    placeholder: 'ប្រភេទប្រតិបត្តិការ',
    staffHistory: 'ជ្រើសរើសបុគ្គលិក',
    languageTitle: 'ភាសាអង់គ្លេស',
    date: 'កាលបរិច្ឆេទ',
    download: 'ទាញយក',
    download_excel: 'ទាញយក Excel',
    download_pdf: 'ទាញយក Barcode',
    currentTitle: 'រូបិយប័ណ្ណ',
    Selectperiod: 'ជ្រើសរើសរយៈពេល',
    TransactionType: 'ប្រភេទប្រតិបត្តិការ',
    SelectCustomer: 'ជ្រើសរើសអតិថិជន',
    invoice: 'វិក្កយបត្រ',
    login: {
        google: 'ចូលប្រើដោយ Google',
        apple: 'ចូលប្រើដោយ Apple'
    },
    trusted_by: {
        title: 'ទទួលបានទំនុកចិត្តពីអាជីវកម្មជាង ៥០,០០០ \n នៅទូទាំងឥណ្ឌូណេស៊ី 🇮🇩'
    },
    privacyPolicyOne: "ដោយចូលប្រើ អ្នកយល់ព្រមនឹង",
    privacyPolicyTwo: 'គោលការណ៍ភាពឯកជន',
    manufacture: 'ផលិតកម្ម',
    warehouse: 'ឃ្លាំង',
    error: {
        title: 'អូហ៊ូ! មានអ្វីមួយខុសហើយ',
        description: 'មានកំហុសដែលមិនបានរំពឹងទុក។ សូមផ្ទុកទំព័រឡើងវិញ ឬត្រឡប់ទៅទំព័រដើមវិញ។',
        refresh: 'ផ្ទុកទំព័រឡើងវិញ',
        go_back: 'ត្រឡប់ទៅផ្ទះវិញ',
        not_found: 'រកមិនឃើញទំព័រ'
    },
    totalPurchasePrice: 'តម្លៃទិញសរុប',
    pageTotalPurchaseAmount: 'ចំនួនទិញសរុបតាមទំព័រ',
    approval_status: 'ស្ថានភាពអនុម័ត',
    pending: 'កំពុងរង់ចាំ',
    approved: 'បានអនុម័ត',
    rejected: 'បានបដិសេធ',
    select_fields: 'ជ្រើសរើសវាល',
    syncWithTally: 'ធ្វើសមកាលកម្មជាមួយ Tally',
    importFromTally: 'នាំចូលពី Tally',
    exportToTally: 'នាំចេញទៅ Tally',
    All: 'ទាំងអស់',
    Approval: 'ការអនុម័ត'
}

export default common
